import { ThemePrepared } from '@fluentui/react-northstar';
import { useContext } from 'react';
// TODO - get rid of this once ThemeContext is directly available from stardust (fluent-ui)
// @ts-ignore
import { ThemeContext } from 'react-fela';

export const useTeamsTheme = () =>
  useContext<{
    theme: ThemePrepared;
  }>(ThemeContext);
